<script setup>
defineProps({
    titulo: {
        type: [String, Number],
    },
    descricao: {
        type: String,
    },
});
</script>

<template>
    <div class="flex flex-column" style="gap: 0.19rem;">
        <h4 v-if="titulo" class="font-semibold text-sm m-0">{{ titulo }}</h4>

        <slot name="titulo"></slot>

        <p v-if="descricao" class="font-medium text-xs text-500 m-0">
            {{ descricao }}
        </p>

        <p class="font-medium text-xs text-500 m-0">
            <slot name="descricao"></slot>
        </p>
    </div>
</template>